<template>
  <article ref="article" class="articles-item">
    <a class="articles-item__link" :href="link" @click="handleRedirect($event, link)">
      <img class="articles-item__img" :src="img" :alt="title" />
      <div class="articles-item__info">
        <span v-if="category" class="articles-item__category">{{ category }}</span>
        <span class="articles-item__date">{{ date }}</span>
      </div>
      <h4 class="articles-item__title">{{ title }}</h4>
      <span class="articles-item__descr">{{ description }}</span>
    </a>
  </article>
</template>

<script>
import { transliteration } from '../../../mixins/transliteration'
import { GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'ArticlesSliderItem',
  mixins: [transliteration],
  props: {
    blockName: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    position: {
      type: Number,
      default: null
    }
  },
  methods: {
    async handleRedirect (e, link) {
      e.preventDefault()

      await GoogleTagManagerService.promotionClickEvent({
        analyticsData: [
          {
            'name': this.transliterate(this.title),
            'creative': this.transliterate(this.blockName),
            'position': 'slot' + this.position
          }
        ]
      })
      location.href = link
    }
  },
  mounted () {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        // GoogleTagManagerService.promotionViewEvent({
        //   analyticsData: [
        //     {
        //       'name': this.transliterate(this.title),
        //       'creative': this.transliterate(this.blockName),
        //       'position': 'slot' + this.position
        //     }
        //   ]
        // })

        observer.unobserve(this.$refs.article)
      }
    })
    setTimeout(() => {
      observer.observe(this.$refs.article)
    }, 0)
  }
}
</script>

<style scoped lang="sass">

// ARTICLES ITEM
.articles-item__link
  display: block
  width: 100%
  position: relative
  padding-top: 44.5%

.articles-item__img
  display: block
  width: 100%
  position: absolute
  left: 0
  top: 0

.articles-item__info
  margin-top: 20px

.articles-item__category
  color: $main-color
  text-transform: uppercase
  letter-spacing: 0.1em
  font-size: 12px
  font-weight: 500
  margin-right: 20px

.articles-item__date
  color: $placeholder-color
  font-size: 12px

.articles-item__title
  color: $text-color
  font-size: 16px
  font-weight: 500
  margin: 10px 0 0

.articles-item__descr
  display: block
  color: $placeholder-color
  font-size: 14px
  margin: 10px 0 0
</style>
